import { i18n as I18nInstance } from "i18next";
import { getTranslationsByLang } from "./xhr";
import {
  getCachedTranslationResources,
  getTranslationHash,
  setCachedTranslationResources,
} from "./translationCache";
import { staticFallbacks, TranslationResources } from "./translationResources";

export const inMemoryLangCache: Record<string, boolean> = {};

const getStaticFallback = (lang: string) =>
  staticFallbacks[lang] || staticFallbacks.lt;

const extractTranslationResources = (
  response: unknown,
): TranslationResources => {
  const responseBody = response as {
    data?: TranslationResources;
  };

  return responseBody?.data || (response as TranslationResources);
};

export const getInitialTranslationResources = (lang: string) =>
  getCachedTranslationResources(lang)?.resources || getStaticFallback(lang);

export const applyTranslationResources = (
  i18n: I18nInstance,
  lang: string,
  resources: TranslationResources,
) => {
  Object.keys(resources).forEach((namespace) => {
    i18n.addResourceBundle(lang, namespace, resources[namespace], true, true);
  });

  inMemoryLangCache[lang] = true;
};

export const refreshTranslationResources = async (
  i18n: I18nInstance,
  lang: string,
) => {
  try {
    const response = await getTranslationsByLang(lang);
    const remoteResources = extractTranslationResources(response);
    const remoteHash = getTranslationHash(remoteResources);
    const cachedHash = getCachedTranslationResources(lang)?.hash;

    if (remoteHash !== cachedHash) {
      applyTranslationResources(i18n, lang, remoteResources);
      setCachedTranslationResources(lang, remoteResources);

      if (i18n.language === lang) {
        await i18n.changeLanguage(lang);
      }
    }
  } catch (error) {
    console.warn(
      `Failed to refresh translations for "${lang}", using local resources.`,
      error,
    );
  }
};
